import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomSwitch from '../CustomSwitch';

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:1280px)');

  const handleViewChange = (event) => {
    const newPath = event.target.checked ? '/memo' : '/';
    navigate(newPath);
  };

  const title = location.pathname === '/memo'
    ? '取材メモ管理'
    : '取材スケジュール管理';

  const headerColor = location.pathname === '/memo' ? '#388e3c' : '#1976d2';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: 1920,
        width: '100%',
        mx: 'auto',
        p: 2,
        bgcolor: headerColor,
        color: '#ffffff',
        position: 'relative',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: isMobile ? '0.9rem' : '1.25rem',
        }}
      >
        {title}
      </Typography>

      <Box sx={{ mr: isMobile ? 6 : 0 }}>
        <CustomSwitch
          checked={location.pathname === '/memo'}
          onChange={handleViewChange}
        />
      </Box>
    </Box>
  );
};

export default AppHeader;